import Member from './Members';
import ViewMember from './ViewMember';

export const MEMBERS_ROUTE = "/members";
export const ADD_MEMBER_ROUTE = MEMBERS_ROUTE + "/new";
export const VIEW_MEMBER_ROUTE = MEMBERS_ROUTE + "/view";

export const routes = [
    {
        path: MEMBERS_ROUTE,
        component: Member,
        exact: true
    },
    {
        path: ADD_MEMBER_ROUTE,
        component: ViewMember,
        exact: true
    },
    {
        path: VIEW_MEMBER_ROUTE + "/:id",
        component: ViewMember,
        exact: true
    }
]


